module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch04"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("FOUR")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("If someone would just say how long she’s been here, she’d be grateful. Three hours or thirteen. One day or two.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Surely not two.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She has to think of night. The number of times it’s been dark. One. She saw darkness. No, she dreamed the dark. She must have been unconscious. Otherwise, she’d have been frightened. She’s frightened now. If only she could stop shivering.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She stares into an upturned root that has been wrenched up and off the ground, but is still attached to the base of a giant tree. The root, longer than her body, arcs like a crocodile that had its belly slit mid-air. It’s even complete with a cold, dark eye. The tree must be half-alive, half-dead; it lists heavily and there are no branches on one side. Her eyes follow the lean all the way to slanted sky. She’s forced to squint because it pains her to look at the waning light. Does she have a bruised orbit? Is one eye swollen? Thirst scrapes at her throat like a claw. She sees a motley patch of cloud attached to a long stem. As it "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("trembles, her bones sway with its motion. A crow caws, out of sight, and then barks like a sick dog.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Who has not imagined horror? She wants to howl, but what good will howling do? If she closes her eyes, darkness will fall. It behooves her to think of morning light.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The word "), _c('em', [_vm._v("behooves")]), _vm._v(" drops into her mind like a discarded password rediscovered. The word "), _c('em', [_vm._v("behooves")]), _vm._v(" makes her want to weep. She raises her head and once more looks back towards the car. At the same moment, she clearly and accurately remembers her own name.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c16ef8f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch04.vue
// module id = 96
// module chunks = 0